// QC #19/#27 — module Vận hành NLĐ phải show NLĐ columns thay vì
// KH columns (spec T-VH-01 entry KH-listing, nhưng KH yêu cầu list NLĐ
// trực tiếp). Columns chuẩn QC yêu cầu:
//   stt, mã NLĐ, họ tên NLĐ, CMND/CCCD, giới tính, ngày sinh, ngày vào làm.
//
// Drill-down từ row vẫn dùng worker_id để mở chi tiết NLĐ.
import { ColumnDef, ColumnResizeMode, createColumnHelper } from '@tanstack/react-table';

import { TableHeaderCell } from '@/components/molecules/TableHeaderCell';
import { WorkerModel } from '@/modules/worker/models';

function getColumnDef(
  columnResizeMode: ColumnResizeMode = 'onChange'
): ColumnDef<WorkerModel, any>[] {
  const columnHelper = createColumnHelper<WorkerModel>();

  return [
    columnHelper.accessor('id', {
      cell: ({ row }) => row.index + 1,
      enableSorting: false,
      header: ({ header }) => (
        <TableHeaderCell
          className="w-40px"
          columnResizeMode={columnResizeMode}
          header={header}
          title="STT"
        />
      ),
    }),
    columnHelper.accessor('code', {
      enableSorting: false,
      header: ({ header }) => (
        <TableHeaderCell
          className="w-120px"
          columnResizeMode={columnResizeMode}
          header={header}
          title="Mã NLĐ"
        />
      ),
    }),
    columnHelper.accessor('full_name', {
      enableSorting: false,
      header: ({ header }) => (
        <TableHeaderCell
          className="w-200px"
          columnResizeMode={columnResizeMode}
          header={header}
          title="Họ tên"
        />
      ),
    }),
    columnHelper.accessor('id_number', {
      enableSorting: false,
      header: ({ header }) => (
        <TableHeaderCell
          className="w-150px"
          columnResizeMode={columnResizeMode}
          header={header}
          title="CCCD"
        />
      ),
    }),
    columnHelper.accessor('gender', {
      cell: ({ getValue }) => {
        const g = getValue();

        return g === 'male' ? 'Nam' : g === 'female' ? 'Nữ' : g ?? '-';
      },
      enableSorting: false,
      header: ({ header }) => (
        <TableHeaderCell
          className="w-100px"
          columnResizeMode={columnResizeMode}
          header={header}
          title="Giới tính"
        />
      ),
    }),
    columnHelper.accessor('birthday', {
      enableSorting: false,
      header: ({ header }) => (
        <TableHeaderCell
          className="w-130px"
          columnResizeMode={columnResizeMode}
          header={header}
          title="Ngày sinh"
        />
      ),
    }),
    columnHelper.accessor('phone', {
      enableSorting: false,
      header: ({ header }) => (
        <TableHeaderCell
          className="w-130px"
          columnResizeMode={columnResizeMode}
          header={header}
          title="SĐT"
        />
      ),
    }),
  ];
}

export { getColumnDef };
